import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";
import ScrollAnimation from "react-animate-on-scroll";


const teamData = [
    {
        image: 'sunil',
        name: 'Sunil Kumar Rumalla',
        designation: 'President, UFTAA',
    },
    {
        image: 'Yossi',
        name: 'Yossi Fatael',
        designation: 'Vice President, UFTAA',
    },
    {
        image: 'WILLIAM',
        name: 'William D’souza',
        designation: 'Vice President (Finance)',
    },
    {
        image: 'Gurcun',
        name: 'Cetin Gurcun',
        designation: 'Vice President (Tourism)',
    },
    {
        image: 'Varsha',
        name: 'Varsha Ramchurn',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'Olivier',
        name: 'Joe Borg Olivier',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'DUMINDA',
        name: 'Duminda  Kuruwitaarachch',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'JOSEPH',
        name: 'Dr Joseph Kithitu',
        designation: 'Board Member,UFTAA',
    },
    {
        image: 'MARIEGEL',
        name: 'Mariegel Manotok',
        designation: 'Board Member,UFTAA',
    },

]

const teamData2 = [
    {
        image: 'rohit',
        name: 'Rohit Hangal',
        designation: 'Secretary',
    },
    {
        image: 'Monik',
        name: 'Monik Dharamshi',
        designation: 'Treasurer',
    },
    {
        image: 'Shalini',
        name: 'Shalini Khanna Charles',
        designation: 'Director PR',
    },
    {
        image: 'Raja',
        name: 'Raja Gopaal Iyer',
        designation: 'Director YS',
    }
]


const auditor = [
    {
        image: 'Varadaraj',
        name: 'M Varadaraj Prabhu',
        designation: 'Sr. Auditor',
    },
    {
        image: 'sheri',
        name: 'Dr Sheri Kurian',
        designation: 'Jr. Auditor',
    }
]


const NationalBoard = () => {
    return (
        <>
            <SEO title="Leadership" />
            <Layout>
                <BreadcrumbOne 
                    title="Leadership"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Leadership"
                />
            <div className="main-content">
            <div className="rwt-team-area rn-section-gap">
        <div className="container">
        <div className="row row--15">
            {teamData.map((data, index) => (
                <div className="col-lg-3 col-md-6 col-12 mt--30" key={index}>
                    <div className={`rn-team team-style-default`}>
                        <ScrollAnimation 
                        animateIn="fadeInUp"
                        animateOut="fadeInOut"
                        animateOnce={true}>
                            <div className="inner">
                                <figure className="thumbnail">
                                    <img src={`./images/team/${data.image}.jpg`} style={{borderRadius:"0"}} alt="Corporate React Template" />
                                </figure>
                                <figcaption className="content">
                                    <h2 className="title" style={{fontSize:"20px"}}>{data.name}</h2>
                                    <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                  
                                </figcaption>
                            </div>
                        </ScrollAnimation>
                    </div>
                </div>
            ))}
        </div>
        </div>
        </div>
        </div>
        </Layout>
        </>
    )
}
export default NationalBoard;